import React, { Component } from 'react';
import styled from 'styled-components';
import media from 'src/styles/media';

import imgMap from 'src/assets/images/map-v6@2x.png';
import mapData from 'src/data/map';
import Category from 'src/components/Map/elements/Category';
import Pin from 'src/components/Map/elements/Pin';

class Map extends Component {
  state = {
    category: null,
  };

  renderPoints(index) {
    return mapData[index].points.map((point, pointIndex) => {
      return (
        <StyledPin
          fill={mapData[index].fill}
          index={pointIndex + 1}
          top={point.top}
          left={point.left}
        />
      );
    });
  }

  handleCategory = index => {
    if (this.state.category === index) {
      this.setState({ category: null });
    } else {
      this.setState({ category: index });
    }
  };

  render() {
    return (
      <Root>
        <MobileTitle>Interactive Map</MobileTitle>
        <Container>
          <MapImage src={imgMap} alt="618 Carnarvon Map" />
          {this.state.category !== null &&
            this.renderPoints(this.state.category)}
        </Container>
        <Categories>
          <DesktopTitle>Interactive Map</DesktopTitle>
          {mapData.map((category, index) => (
            <Category
              index={index}
              category={category}
              handleCategory={this.handleCategory}
              shown={this.state.category === index}
              key={index}
            />
          ))}
        </Categories>
      </Root>
    );
  }
}

export default Map;

const Root = styled.div`
  @media (min-width: ${media.mdup}) {
    display: flex;
    position: relative;
    z-index: 201;
  }
`;

const Container = styled.div`
  width: 100%;
  height: 60vw;
  position: relative;
  @media (min-width: ${media.mdup}) {
    order: 2;
    width: 75%;
    height: 53vw;
    /* min-height: 635px; */
  }
  @media (min-width: ${media.lgup}) {
    /* min-height: 635px; */
    height: 47vw;
  }
`;

const MapImage = styled.img`
  position: relative;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  @media (min-width: ${media.mdup}) {
    /* object-fit: cover; */
  }
  @media (min-width: ${media.lgup}) {
    object-fit: inherit;
  }
`;

const MobileTitle = styled.h2`
  font-family: ${({ theme }) => theme.fontHeader};
  text-transform: uppercase;
  color: ${({ theme }) => theme.colorPrimary};
  text-align: center;
  font-weight: 500;
  margin-bottom: 20px;
  @media (min-width: ${media.mdup}) {
    display: none;
  }
`;

const DesktopTitle = styled.h2`
  display: none;
  @media (min-width: ${media.mdup}) {
    display: block;
    font-family: ${({ theme }) => theme.fontHeader};
    text-transform: uppercase;
    color: ${({ theme }) => theme.colorPrimary};
    text-align: center;
    font-weight: 500;
    margin: 20px 0 40px;
  }
`;

const Categories = styled.div`
  background-color: #1a3346;
  padding: 20px 0;
  @media (min-width: ${media.mdup}) {
    order: 1;
    width: 25%;
  }
`;

const StyledPin = styled(Pin)`
  position: absolute;
  top: ${props => props.top};
  left: ${props => props.left};
  width: 3%;
  height: 4%;
`;



// WEBPACK FOOTER //
// ./src/components/Map/Map.js